import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { persistor, store } from "./api/store";

import Dashboard from "pages/Dashboard";
import Loader from "components/global/Loader";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { authService } from "api";
import Login from "views/onboarding/Login";
import AuthRedirect from "pages/AuthRedirect";
import HelpCenter from "views/HelpCenter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MobileRedirect from "pages/MobileRedirect";
import RegisterWithSocials from "views/onboarding/RegisterWithSocials";
import LoginWithCode from "views/onboarding/LoginWithCode";
import Register from "views/onboarding/Register";
import ForgotPassword from "pages/ForgotPassword";
import VerifyEmail from "views/onboarding/VerifyEmailNew";
import Onboarding from "views/onboarding/Onboarding";
import RegisterWithEmail from "views/onboarding/RegisterWithEmail";
import LoginWithEmail from "views/onboarding/LoginWithEmail";
import SelectChannel from "pages/SelectAccount";
import MiniApp from "views/miniApps/MiniAppsHome";

const queryClient = new QueryClient();

// Pages
const PageNotFound = lazy(() => import("pages/PageNotFound"));
const AffiliateEarningCalculator = lazy(() =>
  import("pages/AffiliateEarningCalculator")
);
const UnsubscribeIndex = lazy(() =>
  import("pages/unsubscribe/UnsubscribeIndex")
);
const PlannerAccessCode = lazy(() =>
  import("views/postPlanner/clientView/AccessCodePage")
);
const ClientDraftPage = lazy(() => import("views/drafts/clientView/DraftPage"));
const Planner = lazy(() =>
  import("views/postPlanner/clientView/ClientViewIndex")
);
// Axios interceptors
authService();

function App() {
  useEffect(() => {
    const mobileUrl = window.location.search;
    if (mobileUrl.includes("postpaddy-mobile")) {
      localStorage.setItem("mobileUrl", "postpaddy-mobile");
    }
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Loader className="cover" />}>
            <Router>
              <div className="App">
                <HelpCenter />
                <Switch>
                  <Route
                    exact
                    path="/"
                    component={() => <Redirect to="/dashboard" />}
                  />
                  <Route exact path="/sign-in" component={Login} />
                  <Route
                    exact
                    path="/sign-in/email"
                    component={LoginWithEmail}
                  />
                  <Route
                    exact
                    path="/sign-in/with-code"
                    component={LoginWithCode}
                  />
                  <Route exact path="/sign-up" component={Register} />
                  <Route
                    exact
                    path="/sign-up/email"
                    component={RegisterWithEmail}
                  />
                  <Route
                    exact
                    path="/sign-up/:social"
                    component={RegisterWithSocials}
                  />
                  <Route
                    exact
                    path="/auth/:provider/callback"
                    component={AuthRedirect}
                  />
                  <Route
                    exact
                    path="/auth/select-channel/:platform"
                    component={SelectChannel}
                  />
                  <Route
                    exact
                    path="/mobile-connect-channel/redirectmobile"
                    component={MobileRedirect}
                  />
                  <Route path="/password-reset" component={ForgotPassword} />
                  <Route exact path="/verify-email" component={VerifyEmail} />
                  <Route path="/dashboard" component={Dashboard} />
                  <Route
                    path="/affiliate-earning-calculator"
                    component={AffiliateEarningCalculator}
                  />
                  <Route path="/onboarding" component={Onboarding} />
                  <Route path="/unsubscribe" component={UnsubscribeIndex} />
                  <Route path="/verify-client" component={PlannerAccessCode} />
                  <Route
                    path="/draft/:draftId/shared"
                    component={ClientDraftPage}
                  />
                  <Route path="/planner/:plannerId/view" component={Planner} />
                  <Route path="/mini-apps" component={MiniApp} />

                  {/* No match */}
                  <Route component={PageNotFound} />
                </Switch>
              </div>
            </Router>
          </Suspense>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
